import React from 'react';
import { doctorInfo } from '../data/mock';
import { Award, Globe, Shield, Heart } from 'lucide-react';

const About = () => {
  const highlights = [
    {
      icon: Award,
      title: 'American-Born Physician',
      description: 'US clinical training with international medical education'
    },
    {
      icon: Globe,
      title: 'Native English Speaker',
      description: 'Seamless communication and culturally aligned care for international patients'
    },
    {
      icon: Shield,
      title: 'Since 2016',
      description: 'Practicing in Ibiza since 2016, serving discerning patients seeking world-class medical support'
    },
    {
      icon: Heart,
      title: 'Concierge Care',
      description: 'Privacy, immediacy, and a human touch beyond the standard clinic experience'
    }
  ];

  return (
    <section id="about" className="section-padding bg-[#f8fafc]">
      <div className="container">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <p className="text-sm uppercase tracking-widest text-[#b8860b] font-medium mb-4">
            About
          </p>
          <h2 className="heading-1 text-[#0f172a] mb-6">
            Excellence in Personalized Medical Care
          </h2>
        </div>

        {/* About Text */}
        <div className="max-w-3xl mx-auto mb-20">
          {doctorInfo.about.split('\n\n').map((paragraph, index) => (
            <p key={index} className="body-regular text-[#475569] mb-6 last:mb-0">
              {paragraph}
            </p>
          ))}
        </div>

        {/* Highlights Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {highlights.map((item, index) => (
            <div key={index} className="text-center group">
              <div className="inline-flex items-center justify-center w-14 h-14 border-2 border-[#0f172a] mb-5 transition-colors group-hover:bg-[#0f172a] group-hover:border-[#0f172a]">
                <item.icon size={24} className="text-[#0f172a] transition-colors group-hover:text-white" />
              </div>
              <h3 className="text-base font-semibold text-[#0f172a] mb-2">{item.title}</h3>
              <p className="text-sm text-[#64748b]">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;
